import * as React from 'react'
import Header from "./Header";
import NotifyBar from "../notify/NotifyBar";
import ConfirmDialog from "../confirm/ConfirmDialog";
import AlertDialog from "../alert/AlertDialog";
import { Box } from '@mui/material';
import theme from '../../styles/theme';
import ChatbotDrawer from "../chat/ChatbotDrawer";
import {useEffect, useState} from "react";
import TermsOfUseDialog from "./TermsOfUseDialog";
import PrivacyPolicyDialog from "./PrivacyPolicyDialog";
import {useResources} from "../../stores/ResourceProvider";
import FacebookPixel from "../FacebookPixel";
import SessionTracker from "../session/SessionTracker";

export interface IPageViewSettings {
  chatOpen: boolean,
  chatView?: string
}

interface IPageProps {
  hideHeader?: boolean
  hideFooter?: boolean
  title?: string
  backgroundColor?: "default" | "paper"
  children: React.ReactNode
}

const Page = ({
  hideHeader,
  hideFooter,
  title,
  backgroundColor,
  children
}: IPageProps) => {
  const [viewStorageKey, setViewStorageKey] = useState<string>("")
  const [chatOpen, setChatOpen] = useState<boolean>(false)
  const [chatView, setChatView] = useState<string | undefined>()

  const {userStore} = useResources()

  useEffect(() => {
    if (title) {
      document.title = `RBC - ${title}`
    } else {
      document.title = "RBC"
    }
  }, [title])

  useEffect(() => {
    if (userStore.isAuthenticated) {
      loadSettings()
    }
  }, [userStore.isAuthenticated])

  const loadSettings = () => {
    let storageKey = viewStorageKey
    if (!storageKey) {
      storageKey = `${userStore.user?.id}.PageViewSettings`
      setViewStorageKey(storageKey)
    }
    const data = window.localStorage.getItem(storageKey)
    if (data && !userStore.isFree) {
      const settings: IPageViewSettings = JSON.parse(data)
      setChatOpen(settings.chatOpen === true)
      if (settings.chatView) {
        setChatView(settings.chatView)
      }
    } else {
      setChatOpen(false)
    }
  }

  const saveSettings = (open: boolean, view?: string) => {
    if (viewStorageKey) {
      const settings = JSON.stringify({
        chatOpen: open,
        chatView: view
      })
      window.localStorage.setItem(viewStorageKey, settings)
    }
  }

  const handleChatOpenChange = (open: boolean, view?: string) => {
    setChatOpen(open)
    if (view) {
      setChatView(view)
    }
    saveSettings(open, view)
  }

  const bgColor = backgroundColor ? theme.palette.background[backgroundColor] : theme.palette.background.default

  return (
    <Box
      sx={{
        flexGrow: 1,
        color: theme.palette.text.primary,
        backgroundColor: bgColor,
        justifyContent: 'space-between',
        display: 'flex',
        flexDirection: 'column',
        minHeight: "100vh",
        overflow: "hidden"
      }}
    >
      {!hideHeader &&
        <Box
          sx={{
            flex: "none",
            height: 76
          }}
        >
          <Header chatOpen={chatOpen} chatView={chatView} onChange={(open: boolean) => handleChatOpenChange(open)}/>
        </Box>
      }
      <AlertDialog />
      <ConfirmDialog />
      <NotifyBar />
      <TermsOfUseDialog/>
      <PrivacyPolicyDialog/>
      <Box
        sx={{
          display: "flex",
          flex: "auto",
          flexGrow: 1,
          minHeight: "100%",
          overflow: "hidden",
          backgroundColor: bgColor
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexGrow: 1,
            minHeight: "100%",
          }}
        >
          {children}
        </Box>
        <ChatbotDrawer open={chatOpen} view={chatView} onChange={(open: boolean, view) => handleChatOpenChange(open, view)}/>
      </Box>
      <FacebookPixel action="PageView"/>
      {/*{!hideFooter &&*/}
      {/*  <Footer />*/}
      {/*}*/}
      {/*<Box sx={{position: "fixed", top:60, left:16, zIndex: 10000}}>*/}
        <SessionTracker/>
      {/*</Box>*/}
    </Box>
  )
}

export default Page